const translations = {
  "en": {
    "Read-only. I can see balances and holdings, never move money. Connected securely through Plaid. Unlink anytime.": "Read-only. I can see balances and holdings, never move money. Connected securely through Plaid. Unlink anytime.",
    "Secured by Plaid • End-to-end encrypted": "Secured by Plaid • End-to-end encrypted"
  },
  "zh-tw": {
    "Read-only. I can see balances and holdings, never move money. Connected securely through Plaid. Unlink anytime.": "唯讀。僅可檢視餘額與持倉，無法移動資金。已透過 Plaid 安全連線。可隨時解除連結。",
    "Secured by Plaid • End-to-end encrypted": "由 Plaid 保障安全 • 端到端加密"
  }
};

export default translations;
